import { Link } from "react-router-dom";
import { Button } from "../ui/button";
import { ArrowRight, Check, UserCheck } from "lucide-react";

const BENEFITS = [
  "Personal artist storefront",
  "Direct messaging with collectors",
  "Worldwide shipping support",
  "Secure Stripe payouts",
];

const STATS = [
  { value: "54", label: "African nations" },
  { value: "120+", label: "Artists on board" },
  { value: "0%", label: "Launch commission" },
  { value: "100%", label: "Original works" },
];

export const SellYourArtSection = () => (
  <section data-testid="sell-your-art-section" className="px-6 md:px-12 lg:px-24 py-24">
    <div className="grid grid-cols-12 gap-y-10 gap-x-4 lg:gap-10 items-center">
      <div className="col-span-12 lg:col-span-7">
        <p className="label-eyebrow text-[#F4C430] [text-shadow:_0_0_1px_#1E3A8A]">— For Artists</p>
        <h2 className="font-serif-display text-4xl md:text-6xl tracking-tight font-medium mt-3 text-[#111] leading-tight">
          Apply to sell on <span className="text-[#1E3A8A]">AfricaArtMasters</span>
        </h2>
        <p className="text-lg text-[#444] mt-6 max-w-xl leading-relaxed">
          A curated network of African contemporary artists. We hand-review every application
          to keep the gallery considered and the collectors confident.
          0% commission during our launch season — the full price reaches you.
        </p>

        <div data-testid="curated-callout" className="mt-8 inline-flex items-start gap-3 border-l-2 border-[#F4C430] bg-[#F4EFE6]/40 px-4 py-3 max-w-xl">
          <UserCheck className="w-5 h-5 text-[#1E3A8A] flex-shrink-0 mt-0.5" strokeWidth={1.5} />
          <p className="text-sm text-[#333]">
            <span className="label-eyebrow text-[#1E3A8A]">Hand-reviewed · </span>
            Every artist and collector is personally vetted by our editors —
            no bots, no spam, no fake listings. Usually approved within 24 hours.
          </p>
        </div>

        <ul className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-3">
          {BENEFITS.map((t) => (
            <li key={t} className="flex items-center gap-2 text-sm text-[#333]">
              <Check className="w-4 h-4 text-[#1E3A8A] flex-shrink-0" /> {t}
            </li>
          ))}
        </ul>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link to="/register">
            <Button
              data-testid="sell-cta-signup"
              className="rounded-none bg-[#1E3A8A] hover:bg-[#162a66] text-white px-7 py-5 h-auto label-eyebrow"
            >
              Apply to sell <ArrowRight className="ml-2 w-3.5 h-3.5" />
            </Button>
          </Link>
          <Link to="/about">
            <Button
              variant="outline"
              className="rounded-none border-[#1E3A8A] text-[#1E3A8A] hover:bg-[#1E3A8A] hover:text-white px-7 py-5 h-auto label-eyebrow"
            >
              How it works
            </Button>
          </Link>
        </div>
      </div>
      <div className="col-span-12 lg:col-span-5">
        <div className="border border-[#E5E0D8] bg-white p-8">
          <p className="label-eyebrow text-[#F4C430] [text-shadow:_0_0_1px_#1E3A8A]">In numbers</p>
          <div className="mt-6 grid grid-cols-2 gap-6">
            {STATS.map((stat, i) => (
              <div key={stat.label} className={i < 2 ? "border-b border-[#E5E0D8] pb-4" : ""}>
                <p className="font-mono-aam text-3xl text-[#1E3A8A]">{stat.value}</p>
                <p className="label-eyebrow text-[#555] mt-1">{stat.label}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  </section>
);
